import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Feature, Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import { OSM } from 'ol/source';
import VectorSource from 'ol/source/Vector';
import { fromLonLat } from 'ol/proj';
import { Point } from 'ol/geom';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import VectorLayer from 'ol/layer/Vector';
import { IPSData } from '../../../../../../../shared/models/ips-data';
import { ModelService } from '../../../../../../../shared/services/model.service';

@Component({
  selector: 'app-map-sensors',
  templateUrl: './map-sensors.component.html',
  styleUrl: './map-sensors.component.scss'
})

export class MapSensorsComponent implements AfterViewInit {
  @ViewChild('mapElement') mapElement!: ElementRef;
  @Input() ipsData!: IPSData;
  capteursModele : any[] = [];

  map!: Map;
  private defaultCenter = fromLonLat([0,0]);
  private defaultZoom = 8.5;

  constructor(private modelService: ModelService){}

  ngAfterViewInit(): void {
    this.defaultCenter = fromLonLat([this.ipsData.geometry.geometry.coordinates[0], this.ipsData.geometry.geometry.coordinates[1]])
    
    this.modelService.getModelData(this.ipsData.modelId).subscribe((res) => {
      res.donneeModele.forEach(capteur => {
        this.capteursModele.push({
          type: capteur.capteur.typeDonnee.type, 
          coord: capteur.capteur.coords, 
          libelle: capteur.capteur.libelle,
          identifier: capteur.capteur.identifier,
          altIdentifier: capteur.capteur.altIdentifier
        });
      });

      this.initMap();
    });
    
  }

  private initMap(): void {
    if(!this.map) {
      this.map = new Map({
        target: this.mapElement.nativeElement,
        layers: [
          new TileLayer({
            source: new OSM()
          })
        ],
        view: new View({
          center: this.defaultCenter,
          zoom: this.defaultZoom,
        }),
      });

      setTimeout(() => {
        this.map.updateSize();
      }, 0);
    }
    else {
      this.map.setView(new View({
        center: this.defaultCenter,
        zoom: this.defaultZoom,
      }));
      this.map.setLayers([new TileLayer({source: new OSM()})]);

      setTimeout(() => {
        this.map.updateSize();
      }, 0);
    }

    this.addPoints();
  }

  addPoints() {
    const vectorSource = new VectorSource();
    this.capteursModele.forEach(capteur => {
      
      const capteurName = capteur.identifier;
      
      const feature = new Feature({
        geometry: new Point(fromLonLat(capteur.coord.geometry.coordinates)),
        name: capteurName
      });

      const iconStyle = new Style({
        image: new Icon({
          anchor: [0.5, 1],
          src: this.getIconClass(capteur.type)
        })
      });

      feature.setStyle(iconStyle);
      vectorSource.addFeature(feature);
    });

    const vectorLayer = new VectorLayer({
      source: vectorSource
    });

    this.map.addLayer(vectorLayer);

    const info = document.getElementById('info');

    let currentFeature: any;
    if(info){
      const displayFeatureInfo =  (pixel: any, target: any) => {
      const feature = target.closest('.ol-control')
        ? undefined
        : this.map.forEachFeatureAtPixel(pixel, function (feature: any) {
            return feature;
          });
      if (feature) {
        info.style.left = pixel[0] + 'px';
        info.style.top = (pixel[1] + 250) + 'px';
        if (feature !== currentFeature) {
          info.style.visibility = 'visible';
          info.innerText = feature.get('name');
        }
      } else {
        info.style.visibility = 'hidden';
      }
      currentFeature = feature;
      };

      this.map.on('pointermove',  (evt) => {
        if (evt.dragging) {
          info.style.visibility = 'hidden';
          currentFeature = undefined;
          return;
        }
        const pixel = this.map.getEventPixel(evt.originalEvent);
        displayFeatureInfo(pixel, evt.originalEvent.target);
      });

      this.map.getTargetElement().addEventListener('pointerleave', function () {
        currentFeature = undefined;
        info.style.visibility = 'hidden';
      });
    }
    
  }

  getIconClass(typeCapteur: string): string {
    switch (typeCapteur) {
      case 'Pluie':
        return 'assets/images/Poste_de_Pluie-cercle.svg';
      case 'Piezo':
        return 'assets/images/Piezometre-cercle.svg';
      case 'Debit':
        return 'assets/images/Station_de_debit-cercle.svg';
      default:
        return 'pi pi-circle';
    }
  }
}
